<template>
    <div class='wux-toolbar'>
        <div class="wux-toolbar-bd">
            <slot></slot>
        </div>
        <div class="wux-toolbar-ft">
            <slot name="wux-toolbar-ft-before"></slot>
        </div>
        <div class="wux-toolbar-ft">
            <span class="date-desc">{{date_desc}} </span>
            <DatePicker split-panels :editable="false" class="date-box" v-if="date_desc != ''"
                        :value="default_day!=''?default_day:default_days" type="daterange" :options="options"
                        placement="bottom-end" :placeholder="date_desc"
                        @on-change="dateSubmit">
            </DatePicker>
        </div>
        <div class="wux-toolbar-ft">
            <slot name="wux-toolbar-ft-m"></slot>
        </div>
        <div class="wux-toolbar-ft">
            <Input class="text-box" search enter-button :placeholder="$t('search_content')+'...'" autocomplete="off"
                   :value="search_text" @input="searchTextSet" @on-search="searchTextSubmit" />
            <input style="width: 0;height:0;border: 0;float: left" />
            <!--<Input style="opacity: 0; position: absolute" v-show="true"></Input>-->
            <!--<input style="width: 0;height:0;border: 0;float: left" />-->
        </div>
        <div class="wux-toolbar-ft">
            <slot name="wux-toolbar-ft-after"></slot>
            <input style="width: 0;height:0;border: 0;float: left" />
        </div>
    </div>
    <!--<div class='wux-toolbar'>-->
        <!--<div class="wux-toolbar-bd">-->
            <!--<slot></slot>-->
        <!--</div>-->
        <!--<div class="wux-toolbar-ft">-->
            <!--<slot name="wux-toolbar-ft-before"></slot>-->
            <!--<div class="date-desc">{{date_desc}} </div>-->
            <!--<DatePicker split-panels :editable="false" class="date-box" v-if="date_desc != ''"-->
                        <!--:value="default_day!=''?default_day:default_days" type="daterange" :options="options"-->
                        <!--placement="bottom-end" :placeholder="date_desc"-->
                        <!--@on-change="dateSubmit">-->
            <!--</DatePicker>-->
            <!--<div class="fl"><slot name="wux-toolbar-text-before"></slot></div>-->
            <!--<Input class="text-box" search enter-button :placeholder="$t('com.search_content')+'...'" autocomplete="off"-->
                   <!--:value="search_text" @input="searchTextSet" @on-search="searchTextSubmit" />-->
            <!--<input style="width: 0;height:0;border: 0;float: left" />-->
            <!--&lt;!&ndash;<Input style="opacity: 0; position: absolute" v-show="true"></Input>&ndash;&gt;-->
            <!--<slot name="wux-toolbar-ft-after"></slot>-->
            <!--<input style="width: 0;height:0;border: 0;float: left" />-->
        <!--</div>-->
    <!--</div>-->
</template>

<script>
    export default {
        name: "myToolbar",
        model:{ //通过v-model传过来的参数
            prop: 'search_text',
            event: 'emitSearchText'
        },
        props:{
            date_desc: {
                default: "",
                type: String
            },
            default_days: {
                default: () => [],
                type: Array
            },
            default_day: {
                default: "",
                type: String
            },
            search_text: {
                default: "",
                type: String
            }
        },
        data:function(){
            return{
                options: {
                    shortcuts: [
                        {
                            text: this.$t('today'),
                            value () {
                                const start = new Date();
                                return [start, start];
                            }
                        },
                        {
                            text: this.$t('yesterday'),
                            value () {
                                const start = new Date();
                                start.setTime(start.getTime() - 3600 * 1000 * 24 * 1);
                                return [start, start];
                            }
                        },
                        {
                            text: this.$t('last_days_3'),
                            value () {
                                const end = new Date();
                                const start = new Date();
                                start.setTime(start.getTime() - 3600 * 1000 * 24 * 3);
                                return [start, end];
                            }
                        },
                        {
                            text: this.$t('last_days_7'),
                            value () {
                                const end = new Date();
                                const start = new Date();
                                start.setTime(start.getTime() - 3600 * 1000 * 24 * 7);
                                return [start, end];
                            }
                        },
                        {
                            text: this.$t('last_days_30'),
                            value () {
                                const end = new Date();
                                const start = new Date();
                                start.setTime(start.getTime() - 3600 * 1000 * 24 * 30);
                                return [start, end];
                            }
                        },
                        {
                            text: this.$t('last_days_90'),
                            value () {
                                const end = new Date();
                                const start = new Date();
                                start.setTime(start.getTime() - 3600 * 1000 * 24 * 90);
                                return [start, end];
                            }
                        }
                    ]
                }
            }
        },
        methods: {
            searchTextSet: function(value) {
                this.$emit('emitSearchText', value);
            },
            searchTextSubmit: function(value) {
                this.$emit('onSearchTextChange', value);
            },
            dateSubmit:function (value) {
                this.$emit('onDateChange', value);
            }
        }
    }
</script>

<style scoped>
    .wux-toolbar{
        margin-bottom: 10px;
        display: flex;
        align-items: center;
        flex-wrap: wrap;
    }
    .wux-toolbar .wux-toolbar-bd{
        flex: 1;
    }
</style>


// WEBPACK FOOTER //
// src/components/myToolbar.vue